/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FittingTreeViewComponent } from './fitting-tree-view';
import { SysqueTabModel } from 'libs/sysque/shared/ui/src/lib/models/sysque-tab-model';
import {
  ADD_FITTING_TAB_FACADE_TOKEN,
  IAddFittingTabFacade,
} from '../../../../../../toolbelt/data-access/src/lib/domain/facades-models/add-fitting-tab-facade-interface';

import { CurateSearchComponent } from './curate-search';
import { SysqueTabComponent } from '../../../../../../shared/ui/src/lib/components/sysque-tab/sysque-tab.component';

@Component({
  selector: 'sysque-add-fitting-tab',
  templateUrl: './add-fitting-tab.component.html',
  styleUrls: ['./add-fitting-tab.component.scss'],
  standalone: false
})
export class AddFittingTabComponent implements OnInit {
  @ViewChild('tabPanel') addFittingtabPanel: SysqueTabComponent;
  content: SysqueTabModel[] = [
    {
      component: CurateSearchComponent,
      name: 'Curate Search',
      inputs: null,
    },
    {
      component: FittingTreeViewComponent,
      inputs: null,
      name: 'Tree View',
    },
  ];

  constructor(@Inject(ADD_FITTING_TAB_FACADE_TOKEN) public addFittingTabFacade: IAddFittingTabFacade) {

  }
  ngOnInit(): void {
    this.titleClick = this.titleClick.bind(this);
    this.addFittingTabFacade.initializeRootPath();
    this.addFittingTabFacade.getTreeViewRootDirectory();
    this.addFittingTabFacade.notifySelectorChange.next(this.content[0].name);
  }

  titleClick(e: any) {
    this.addFittingTabFacade.notifySelectorChange.next(e.itemData.name);
    this.addFittingTabFacade.getLocalStorageUpdate().next(e.itemData.name);
  }
}
